import { render, staticRenderFns } from "./PartnershipPostCreate.vue?vue&type=template&id=5f077451&scoped=true&"
import script from "./PartnershipPostCreate.vue?vue&type=script&lang=js&"
export * from "./PartnershipPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipPostCreate.vue?vue&type=style&index=0&id=5f077451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f077451",
  null
  
)

export default component.exports